import Head from 'next/head';

import { Brand } from '@/lib/configuration/configuration';

type FaviconLinksProps = {
  brand?: Brand;
};

export const FaviconLinks = ({ brand }: FaviconLinksProps) => {
  const brandName = brand ? brand.toString() : Brand.Breitling;
  let urlPrefix = `/favicon/${brandName}/`;
  if (!urlPrefix || brandName === Brand.Breitling) {
    urlPrefix = `/favicon/`;
  }

  return (
    <Head>
      <link href={`${urlPrefix}favicon.ico`} rel='icon' />
      <link
        href={`${urlPrefix}favicon-16x16.png`}
        rel='icon'
        sizes='16x16'
        type='image/png'
      />
      <link
        href={`${urlPrefix}favicon-32x32.png`}
        rel='icon'
        sizes='32x32'
        type='image/png'
      />
      <link href={`${urlPrefix}apple-touch-icon.png`} rel='apple-touch-icon' />
      <link
        href={`${urlPrefix}android-chrome-192x192.png`}
        rel='icon'
        sizes='192x192'
        type='image/png'
      />
      <link
        href='/favicon/android-chrome-512x512.png'
        rel='icon'
        sizes='512x512'
        type='image/png'
      />
    </Head>
  );
};
